export type ChangeFeedStatus = (
  id: string,
  status: number
) => Promise<Record<string, never>>
